import { createWithEqualityFn } from 'zustand/traditional'

interface VisibilityStore {
    // HOME
    isHomeContentVisible: boolean
    setHomeContentVisible: (isPipMode?: boolean) => void

    // EPG
    isEpgContentVisible: boolean
    setEpgContentVisible: (isPipMode?: boolean) => void

    // TV
    isTvContentVisible: boolean
    setTvContentVisible: (isVisible?: boolean) => void

    // VOD
    isVodContentVisible: boolean
    setVodContentVisible: (isPipMode?: boolean) => void

    // LOGIN
    setLoginContentVisible: () => void

    // SETTINGS
    isSettingsContentVisible: boolean
    setSettingsContentVisible: () => void
}

export const useVisibilityStore = createWithEqualityFn<VisibilityStore>(
    (set) => ({
        // LOGIN
        setLoginContentVisible: () =>
            set(() => ({
                isHomeContentVisible: false,
                isTvContentVisible: false,
                isVodContentVisible: false,
                isEpgContentVisible: false,
                isSettingsContentVisible: false,
            })),

        // HOME
        isHomeContentVisible: false,
        setHomeContentVisible: (isPipMode = false) =>
            set(() => ({
                isLoginContentVisible: false,
                isHomeContentVisible: true,
                isTvContentVisible: isPipMode,
                isVodContentVisible: false,
                isEpgContentVisible: false,
                isSettingsContentVisible: false,
            })),

        // TV
        isTvContentVisible: false,
        setTvContentVisible: (isVisible?: boolean) =>
            set(() => ({
                isLoginContentVisible: false,
                isHomeContentVisible: false,
                isTvContentVisible: isVisible,
                isVodContentVisible: false,
                isEpgContentVisible: false,
                isSettingsContentVisible: false,
            })),

        // EPG
        isEpgContentVisible: false,
        setEpgContentVisible: (isPipMode = false) =>
            set(() => ({
                isLoginContentVisible: false,
                isHomeContentVisible: false,
                isTvContentVisible: isPipMode,
                isVodContentVisible: false,
                isEpgContentVisible: true,
                isSettingsContentVisible: false,
            })),

        // VOD
        isVodContentVisible: false,
        setVodContentVisible: () =>
            set(() => ({
                isLoginContentVisible: false,
                isHomeContentVisible: false,
                isTvContentVisible: false,
                isVodContentVisible: true,
                isEpgContentVisible: false,
                isSettingsContentVisible: false,
            })),

        // SETTINGS
        isSettingsContentVisible: false,
        setSettingsContentVisible: () =>
            set(() => ({
                isLoginContentVisible: false,
                isHomeContentVisible: false,
                isTvContentVisible: false,
                isVodContentVisible: false,
                isEpgContentVisible: false,
                isSettingsContentVisible: true,
            })),
    })
)
